import React from "react";
import { useDispatch } from "react-redux";
import {
  catalogTypeSetSearchText,
  cleanSearchingCatalogTypesPaginated,
  startSearchingCatalogTypesPaginated,
} from "../../app/actions/catalogTypeActions";

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";

const SearchBackCatalogType = ({ searchText, setSearchText, itemsPerPage }) => {
  debugLogPages(":: SearchBackCatalogType");
  
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const onChangeInput = (event) => {
    setSearchText(event.target.value);

    if (event.target.value !== "") {
      trackEvent({ component: "SearchCatalogs", event: "SearchCatalogs-Clicked", search: event.target.value });

      dispatch(catalogTypeSetSearchText(event.target.value));

      dispatch(startSearchingCatalogTypesPaginated(event.target.value, 0, itemsPerPage));
    } else {
      
      dispatch(cleanSearchingCatalogTypesPaginated());

      dispatch(catalogTypeSetSearchText());
    }
  };

  return (
    <div className="row height d-flex justify-content-center align-items-center">
      <div className="col-md-8">
        <div className="search">
          <i className="fa fa-search"></i>
          <input
            type="text"
            className="form-control"
            placeholder={t("general.option_search")}
            value={searchText}
            id="searchText"
            name="searchText"
            onChange={onChangeInput}
          ></input>
        </div>
      </div>
    </div>
  );
};

export default SearchBackCatalogType;
